import {IntermediatePart} from "../../parts/intermediatePart";
import {Vanity} from "../../parts/vanity";

export default class VanityBacksplash extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'vanity_backsplash';
    this.partName = 'Backsplash';
    this.translateId = "visualizer.bathroom.vanity.vanity_backsplash";
    this.dbName = 'Backsplash';
    this.visible = [Vanity.Types.Custom];
    this.canBeDisabled = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new VanityBacksplash())
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    return super.navigationSubItemsWithFilter('CountertopSize', this.getParent().counterTopSize(), filteredAvailableFeatures);
  }

  setDefault(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    const filteredFeatures = this.features && this.features.filter(f => f.matchesMetaForCondition('CountertopSize', counterTopSize)) || [];
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      const hardCodedDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("Aliveri");
      });
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includes("laceholder");
      });
      this.activeFeature = hardCodedDefault || super.setDefault(layout) || filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || super.setDefault(layout) || null;
    }
  }

  setLayers(layout) {
    const counterTopSize = this.getParent().counterTopSize();
    if (this.activeFeature && (this.activeFeature.matchesMetaForCondition('CountertopSize', counterTopSize)
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.getParent().activeSubType_ === Vanity.Types.Custom) {
      const zIndex = zIndexes.Vanity.Custom.VanityBacksplash;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
